import React, { useState, useEffect, useCallback } from "react";
import { Container, Box } from "@material-ui/core";
import {
  Typography,
  AppBar,
  Toolbar,
  Link,
  CardActionArea,
  TextField,
  Button,
  Paper,
  FormControlLabel,
  Checkbox,
  IconButton,
  Avatar,
  Chip,
} from "@material-ui/core";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  LinearProgress,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Switch,
  Divider,
  Popover,
  ButtonGroup,
  Tooltip,
} from "@material-ui/core";
import {
  DesktopMac,
  Add,
  FilterList,
  Assignment,
  Group,
  Close,
  ArrowForwardIos,
  CheckCircle,
  Block,
  Receipt,
  DateRange,
  DevicesOther,
  CreditCard,
} from "@material-ui/icons";
import { withLocalize, Translate } from "react-localize-redux";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/styles";

import MUIDataTable from "mui-datatables";

import { Skeleton } from "@material-ui/lab";
import Format from "date-fns/format";
import { DatePicker } from "@material-ui/pickers";
import { TableFooter, TableCell, TableRow } from "@material-ui/core";

import { useSnackbar } from "notistack";

import {
  FinanceService,
  AdminService,
  ReportingService,
  Validator,
} from "../../../../../../utils/web_config";
//import { useTransactionTypes } from "../../../../hooks/use_hooks";

const axios = require("axios");

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  title: {
    flexGrow: 1,
  },
  btn: {
    textTransform: "capitalize",
  },
  btn2: {
    textTransform: "capitalize",
    border: "dashed grey 1px",
  },
  paper: {
    padding: 15,
  },
  action: {
    borderRadius: 15,
  },
}));

function StockStatus(props) {
  const classes = useStyles();
  const history = useHistory();

  const [accountData, setAccountData] = useState({});
  const [transactions, setTransactions] = useState({
    page: 0,
    count: 1,
    rowsPerPage: 10,
    sortOrder: {},
    status: "Loading stock status...",
    loading: false,
    toggling: false,
    data: [],
  });

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [from, setFrom] = useState({
    value: new Date(),
    error: "",
  });
  const [to, setTo] = useState({
    value: new Date(),
    error: "",
  });

  const [range, setRange] = useState({ index: 0, acnhor: null });

  useEffect(() => {
    var accountData = new AdminService().accountData;
    setAccountData(accountData);
    getTransactions(accountData.token, from.value, to.value);
  }, []);

  const onFromChange = (date) => {
    setFrom({ value: date, error: "" });
    setRange({ ...range, index: null });
    getTransactions(accountData.token, date, to.value);
  };
  const onToChange = (date) => {
    setTo({ value: date, error: "" });
    setRange({ ...range, index: null });
    getTransactions(accountData.token, from.value, date);
  };

  //////////////
  //////////
  const transactionsColums = [
    {
      name: "organization_id",
      label: "org",
      options: {
        filter: false,
        sort: false,
        display: "excluded",
      },
    },
    {
      name: "movement_type",
      label: "Movement",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "item_type",
      label: "Item type",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "item_name",
      label: "Item name",
      options: {
        filter: false,
        sort: false,
        //   customBodyRender: (value) => (
        //     <span>{new Validator().formatMoney(value)}</span>
        //   ),
      },
    },
    {
      name: "previous_quantity",
      label: "Quantity before",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "previous_damaged_quantity",
      label: "Damaged before",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "quantity_in",
      label: "Quantity in",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "quantity_out",
      label: "Quantity out",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "damaged_quantity_in",
      label: "Damaged in",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "damaged_quantity_out",
      label: "Damaged out",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "current_quantity",
      label: "Quantity after",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "current_damaged_quantity",
      label: "Damaged after",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "movement_date",
      label: "Date",
      options: {
        filter: false,
        sort: false,
      },
    },
    
  ];

  const transactionsOptions = {
    filterType: "multiselect",
    elevation: 0,
    selectableRows: "none",
    searchPlaceholder: "Search here...",
    selectableRowsOnClick: true,
    fixedHeader: true,
    // onCellClick: (cellData, cellMeta) => {
    //   var tr = transactions.data[cellMeta.dataIndex];
    //   history.push("/centrika/agents/details/viewTransaction", tr);
    // },
    searchProps: {
      variant: "outlined",
      margin: "dense",
    },
    textLabels: {
      body: {
        noMatch: transactions.status,
      },
    },
    customTableBodyFooterRender: function (opts) {
 

      let sumPrev = opts.data
        ?.map((item) => item.data[4])
        .reduce((prev, curr) => prev + curr, 0);

      let sumPrevDam = opts.data
        ?.map((item) => item.data[5])
        .reduce((prev, curr) => prev + curr, 0);

      let sumQIn = opts.data
        ?.map((item) => item.data[6])
        .reduce((prev, curr) => prev + curr, 0);
      let sumQOut = opts.data
        ?.map((item) => item.data[7])
        .reduce((prev, curr) => prev + curr, 0);

      let sumDamQIn = opts.data
        ?.map((item) => item.data[8])
        .reduce((prev, curr) => prev + curr, 0);
      let sumDamQOut = opts.data
        ?.map((item) => item.data[9])
        .reduce((prev, curr) => prev + curr, 0);

      let sumCurrQ = opts.data
        ?.map((item) => item.data[10])
        .reduce((prev, curr) => prev + curr, 0);

      let sumCurrDamQ = opts.data
        ?.map((item) => item.data[11])
        .reduce((prev, curr) => prev + curr, 0);

      sumPrev = Math.round(sumPrev);
      sumPrevDam = Math.round(sumPrevDam);
      sumQIn = Math.round(sumQIn);
      sumQOut = Math.round(sumQOut);
      sumDamQIn = Math.round(sumDamQIn);
      sumDamQOut = Math.round(sumDamQOut);
      sumCurrQ = Math.round(sumCurrQ);
      sumCurrDamQ = Math.round(sumCurrDamQ);

      return (
        <TableFooter className={classes.stickyFooter}>
          <TableRow>
            {opts.selectableRows !== "none" ? (
              <TableCell className={classes.stickyFooter} />
            ) : null}
            {opts.columns.map((col, index) => {
              if (col.display === "true") {
                if (col.name === "previous_quantity") {
                  return (
                    <TableCell key={index} className={classes.stickyFooter}>
                      Total: <b>{sumPrev}</b>
                    </TableCell>
                  );
                } else if (col.name === "previous_damaged_quantity") {
                  return (
                    <TableCell key={index} className={classes.stickyFooter}>
                      Total: <b>{sumPrevDam}</b>
                    </TableCell>
                  );
                } else if (col.name === "quantity_in") {
                  return (
                    <TableCell key={index} className={classes.stickyFooter}>
                      Total: <b>{sumQIn}</b>
                    </TableCell>
                  );
                } else if (col.name === "quantity_out") {
                  return (
                    <TableCell key={index} className={classes.stickyFooter}>
                      Total: <b>{sumQOut}</b>
                    </TableCell>
                  );
                } else if (col.name === "damaged_quantity_in") {
                  return (
                    <TableCell key={index} className={classes.stickyFooter}>
                      Total: <b>{sumDamQIn}</b>
                    </TableCell>
                  );
                } else if (col.name === "damaged_quantity_out") {
                  return (
                    <TableCell key={index} className={classes.stickyFooter}>
                      Total: <b>{sumDamQOut}</b>
                    </TableCell>
                  );
                } else if (col.name === "current_quantity") {
                  return (
                    <TableCell key={index} className={classes.stickyFooter}>
                      Total: <b>{sumCurrQ}</b>
                    </TableCell>
                  );
                } else if (col.name === "current_damaged_quantity") {
                  return (
                    <TableCell key={index} className={classes.stickyFooter}>
                      Total: <b>{sumCurrDamQ}</b>
                    </TableCell>
                  );
                } else {
                  return (
                    <TableCell key={index} className={classes.stickyFooter} />
                  );
                }
              }
              return null;
            })}
          </TableRow>
        </TableFooter>
      );
    },
  };

  /////////////////////
  const notify = (variant, msg, status) => {
    if (status == 401) {
      history.push("/", { expired: true });
    }
    enqueueSnackbar(msg, {
      variant: variant,
      action: (k) => (
        <IconButton
          onClick={() => {
            closeSnackbar(k);
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      ),
    });
  };

  const capitalize = (s) => {
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  };
  ///////////////////////////////////

  ///////////////////////////////////

  const getTransactions = (token, fromDate, toDate) => {
    const createInstance = axios.create(new AdminService().getHeaders(token));

    setTransactions({ ...transactions, loading: true });

    console.log("getting transactions .....");

    const data = {
      from_date: Format(fromDate, ["yyyy-MM-dd"]),
      to_date: Format(toDate, ["yyyy-MM-dd"]),
    };

    createInstance
      .post(new ReportingService().STOCK_STATUS, data)
      .then(function (response) {
        setTransactions({ ...transactions, loading: false });

        const d = response.data;

        if (d.data.length == 0) {
          setTransactions({
            ...transactions,
            data: d.data,
            status: "There are no status available for selected date range",
          });
        } else {
          var groups = new Validator().groupArrayOfObjects(d.data, "item_type");
          var keys = Object.keys(groups);

          setTransactions({
            ...transactions,
            data: d.data,
            allData: d.data,
            groups: groups,
            keys: keys,
          });
        }
      })
      .catch(function (error) {
        setTransactions({ ...transactions, loading: false });

        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        setTransactions({ ...transactions, status: e });

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  return (
    <div className={classes.root}>
      {/* Dialogs ends here */}

      <Popover
        id={"pop-id"}
        open={range.acnhor != null}
        anchorEl={range.acnhor}
        onClose={() => setRange({ ...range, acnhor: null })}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        elevation={4}
      >
        <Box p={2}>
          <Typography color="textSecondary">Select date range</Typography>
          <Box mt={2} mb={2}>
            <Box>
              <DatePicker
                fullWidth
                disableToolbar
                variant="inline"
                format="yyyy-MM-dd"
                margin="dense"
                maxDate={to.value}
                autoOk
                label={<Translate id="reports.forms.labels.from" />}
                value={from.value}
                inputVariant="outlined"
                onChange={onFromChange}
                InputProps={{
                  disableUnderline: true,
                  style: { paddingRight: 0 },
                }}
              />
            </Box>
            <Box>
              <DatePicker
                fullWidth
                disableToolbar
                variant="inline"
                format="yyyy-MM-dd"
                margin="dense"
                maxDate={new Date()}
                minDate={from.value}
                autoOk
                label={<Translate id="reports.forms.labels.to" />}
                value={to.value}
                inputVariant="outlined"
                onChange={onToChange}
                InputProps={{
                  disableUnderline: true,
                  style: { paddingRight: 0 },
                }}
              />
            </Box>
          </Box>
        </Box>
      </Popover>

      {/* ////////////////////////////// */}
      <Box display="flex" alignItems="center">
        <Box flexGrow={1} display="flex" alignItems="center">
          <Typography variant="h6">
            <b>Stock status</b>
          </Typography>
        </Box>
        <Box display="flex" mr={2} alignItems="center">
          <Box mr={2}>
            <ButtonGroup color="primary" disableElevation>
              <Button
                className={classes.btn}
                variant={range.index == 0 ? "contained" : "outlined"}
                onClick={() => {
                  setRange({ index: 0 });
                  var date1 = new Date();
                  var date2 = new Date();

                  setFrom({ value: date1 });
                  setTo({ value: date2 });
                  getTransactions(accountData.token, date1, date2);
                }}
              >
                Today
              </Button>
              <Button
                className={classes.btn}
                variant={range.index == 1 ? "contained" : "outlined"}
                onClick={() => {
                  setRange({ index: 1 });
                  var date1 = new Date();
                  date1.setDate(date1.getDate() - 7);
                  var date2 = new Date();

                  setFrom({ value: date1 });
                  setTo({ value: date2 });
                  getTransactions(accountData.token, date1, date2);
                }}
              >
                Last week
              </Button>
              <Button
                className={classes.btn}
                variant={range.index == 2 ? "contained" : "outlined"}
                onClick={() => {
                  setRange({ index: 2 });
                  var date1 = new Date();
                  date1.setDate(date1.getDate() - 30);
                  var date2 = new Date();

                  setFrom({ value: date1 });
                  setTo({ value: date2 });
                  getTransactions(accountData.token, date1, date2);
                }}
              >
                Last month
              </Button>
            </ButtonGroup>
          </Box>

          <IconButton
            color="primary"
            onClick={(e) => setRange({ ...range, acnhor: e.currentTarget })}
          >
            <DateRange />
          </IconButton>
        </Box>
      </Box>
      <Box mt={2} />
      <Grid container spacing={2}>
        {transactions?.keys?.map((tr, i) => (
          <Grid item xs={12} sm={4} lg={3}>
            <Paper elevation={0} className={classes.paper}>
              <Box width={1}>
                <Box display="flex" width={1}>
                  <Box flexGrow={1}>
                    <Typography>{tr}</Typography>
                    <Typography color="textSecondary">
                      {transactions?.groups[tr][0].item_name}
                    </Typography>
                  </Box>
                  {tr[0].item_type == "CARD" ? (
                    <CreditCard color="primary" fontSize="large" />
                  ) : (
                    <DevicesOther color="primary" fontSize="large" />
                  )}
                </Box>
                <Box
                  mt={1}
                  mb="4px"
                  display="flex"
                  alignItems="flex-end"
                  justifyContent="space-between"
                  width={1}
                >
                  <Tooltip
                    title={new Validator().sum(
                      transactions?.groups[tr],
                      "current_quantity"
                    )}
                    arrow
                    placement="top"
                  >
                    <Typography variant="h5">
                      {new Validator().sum(
                        transactions?.groups[tr],
                        "current_quantity"
                      )}
                    </Typography>
                  </Tooltip>
                  {new Validator().sum(
                    transactions?.groups[tr],
                    "current_damaged_quantity"
                  ) != 0 && (
                    <Typography color="error" align="right">
                      {new Validator().sum(
                        transactions?.groups[tr],
                        "current_damaged_quantity"
                      )}
                      {" NoK"}
                    </Typography>
                  )}
                </Box>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
      <Box mt={2} />
      {transactions.loading && <LinearProgress />}
      <MUIDataTable
        title={
          "From " +
          Format(from.value, ["MMMM dd"]) +
          " to " +
          Format(to.value, ["MMMM dd"])
        }
        data={transactions.data}
        columns={transactionsColums}
        options={transactionsOptions}
      />
    </div>
  );
}

export default withLocalize(StockStatus);
